module.exports = __webpack_public_path__ + "assets/img/szjz_5.48dcfec2.png";